/** Die dünne Linie oben im Lernbildschirm — Restmenge der Sitzung, sonst nichts. */
export function Fortschrittslinie({ erledigt, gesamt }) {
  const anteil = gesamt > 0 ? Math.min(100, (100 * erledigt) / gesamt) : 0
  return (
    <div
      class="fortschrittslinie"
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={gesamt}
      aria-valuenow={erledigt}
      aria-label="Fortschritt der Sitzung"
    >
      <div class="fortschrittslinie__fuellung" style={{ width: `${anteil}%` }} />
    </div>
  )
}
